import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Brand } from "@/components/Layout";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) { setError("Le mot de passe doit contenir au moins 8 caractères."); return; }
    if (password !== confirm) { setError("Les deux mots de passe ne correspondent pas."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => navigate("/login"), 2200);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0908] text-[#F4F0EA] flex flex-col">
      <header className="max-w-7xl mx-auto w-full px-6 py-8"><Brand /></header>
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-md">
          <div className="text-[10px] tracking-[0.4em] text-[#C5A059] uppercase mb-4">Espace propriétaire</div>
          <h1 className="font-serif text-4xl sm:text-5xl font-light mb-10">Nouveau mot de passe.</h1>

          {!token ? (
            <div className="text-sm text-[#E08D8D] border border-[#8C3131]/40 bg-[#8C3131]/10 p-4" data-testid="reset-no-token">
              Lien invalide. Veuillez refaire une demande depuis « Mot de passe oublié ».
            </div>
          ) : done ? (
            <div className="space-y-6" data-testid="reset-success">
              <p className="text-sm text-[#A39E93]">Votre mot de passe a été mis à jour. Redirection vers la connexion…</p>
              <Link to="/login" className="btn-primary w-full justify-center">Se connecter</Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-6" data-testid="reset-form">
              <div>
                <Label htmlFor="pwd" className="text-xs uppercase tracking-[0.2em] text-[#A39E93]">Nouveau mot de passe</Label>
                <Input id="pwd" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 bg-[#141311] border-[#2C2A26] h-12" required data-testid="reset-password" />
                <p className="text-xs text-[#6B6760] mt-2">8 caractères minimum.</p>
              </div>
              <div>
                <Label htmlFor="pwd2" className="text-xs uppercase tracking-[0.2em] text-[#A39E93]">Confirmer le mot de passe</Label>
                <Input id="pwd2" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-2 bg-[#141311] border-[#2C2A26] h-12" required data-testid="reset-confirm" />
              </div>
              {error && <div className="text-sm text-[#E08D8D] border border-[#8C3131]/40 bg-[#8C3131]/10 p-3" data-testid="reset-error">{error}</div>}
              <button type="submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-50" data-testid="reset-submit">
                {loading ? "Enregistrement…" : (<><KeyRound className="w-4 h-4" strokeWidth={1.5} /> Définir le mot de passe</>)}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
